function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n2 = 0, F = function F() {}; return { s: F, n: function n() { return _n2 >= r.length ? { done: !0 } : { done: !1, value: r[_n2++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/*! License details at fancyapps.com/license */
import { isPlainObject as t } from "../utils/isPlainObject.js";
import { extend as e } from "../utils/extend.js";
import { replaceAll as n } from "../utils/replaceAll.js";
import { clamp as i } from "../utils/clamp.js";
import { Sync as o } from "./carousel.sync.js";
import { Lazyload as l } from "./carousel.lazyload.js";
import { addClass as s } from "../utils/addClass.js";
var r = {
  Carousel: {
    Lazyload: {
      showLoading: !1
    }
  },
  minCount: 2,
  showOnStart: !0,
  thumbTpl: '<button aria-label="Slide to #{{page}}"><img draggable="false" alt="{{alt}}" data-lazy-src="{{src}}" /></button>',
  type: "modern"
};
var u;
var a = function a() {
  var a,
    d,
    c,
    f = 0,
    m = 0,
    g = !0;
  function h(e) {
    var n = null == a ? void 0 : a.getOptions().Thumbs;
    var i = (t(n) ? Object.assign(Object.assign({}, r), n) : r)[e];
    return i && "function" == typeof i && a ? i(a) : i;
  }
  function v() {
    if (!a) return !1;
    if (!1 === (null == a ? void 0 : a.getOptions().Thumbs)) return !1;
    var t = 0;
    var _iterator = _createForOfIteratorHelper(a.getSlides()),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _e = _step.value;
        _e.thumbSrc && t++;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return t >= h("minCount");
  }
  function p() {
    return "modern" === h("type");
  }
  function b() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
    var e;
    var n = null == a ? void 0 : a.getContainer();
    if (!a || !n || c) return;
    if (!v()) return;
    if (!c) {
      var _t = n.nextElementSibling;
      (null == _t ? void 0 : _t.classList.contains("f-thumbs")) && (c = _t);
    }
    if (!c) {
      c = document.createElement("div");
      var _t2 = h("parentEl");
      _t2 ? _t2.insertAdjacentElement("beforeend", c) : n.insertAdjacentElement("afterend", c);
    }
    var i = null === (e = h("Carousel")) || void 0 === e ? void 0 : e.classes;
    (null == i ? void 0 : i.container) && s(c, i.container), s(c, "f-thumbs"), s(c, "is-".concat(h("type"))), s(c, "is-syncing"), t && (c.style.maxHeight = "0px");
  }
  function y(t) {
    var e = t.thumb ? t.thumb instanceof HTMLImageElement ? t.thumb.src : t.thumb : t.thumbSrc || void 0,
      i = void 0 === t.thumbAlt ? "Thumbnail #".concat(t.index) : t.thumbAlt + "";
    var o = h("thumbTpl");
    return o = n(o, "{{alt}}", i), o = n(o, "{{src}}", e + ""), o = n(o, "{{index}}", "".concat(t.index)), o = n(o, "{{page}}", "".concat(t.index || 1)), {
      html: o,
      class: t.thumbClass
    };
  }
  function S() {
    var t;
    if (!u) return;
    if (!a || !c || d) return;
    var n = [];
    var _iterator2 = _createForOfIteratorHelper(a.getSlides()),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _t5 = _step2.value;
        n.push(y(_t5));
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    n.length && (d = u(c, e({}, {
      Sync: {
        target: a
      },
      Lazyload: {
        preload: 1
      },
      slides: n,
      classes: {
        container: "f-thumbs",
        viewport: "f-thumbs__viewport",
        slide: "f-thumbs__slide"
      },
      initialSlide: a.getOptions().initialPage,
      center: !0,
      fill: !p(),
      infinite: !1,
      dragFree: !0,
      rtl: a.getOptions().rtl || !1,
      slidesPerPage: function slidesPerPage(t) {
        var e = 0;
        return p() && (!function () {
          if (!p()) return;
          if (!c) return;
          var t = function t(_t3) {
            return c && parseFloat(getComputedStyle(c).getPropertyValue("--f-thumb-" + _t3)) || 0;
          };
          f = t("width"), m = t("clip-width");
        }(), e = 4 * (f - m)), t && t.getTotalSlideDim() <= t.getViewportDim() - e ? 1 / 0 : 1;
      }
    }, r.Carousel || {}, h("Carousel") || {}), {
      Sync: o,
      Lazyload: l
    }), d.on("ready", function () {
      null == a || a.emit("thumbs:ready");
    }), d.on("destroy", function () {
      null == a || a.emit("thumbs:destroy");
    }), d.init(), null === (t = d.getGestures()) || void 0 === t || t.on("start", function () {
      g = !1;
    }), d.on("click", function (t, e) {
      var n = e.target;
      if (n) {
        var _t4 = n.matches("button") ? n : n.firstElementChild;
        _t4 && _t4.matches("button") && (e.preventDefault(), _t4.focus({
          preventScroll: !0
        }));
      }
    }), s(a.getContainer(), "has-thumbs"), L());
  }
  function x() {
    v() && h("showOnStart") && (b(), S());
  }
  function C() {
    var t;
    v() && (null == a || a.on("addSlide", E), null == a || a.on("click", T), null === (t = null == a ? void 0 : a.getGestures()) || void 0 === t || t.on("start", P));
  }
  function P() {
    var t, e;
    g = !0;
    (null === (t = document.activeElement) || void 0 === t ? void 0 : t.closest(".f-thumbs")) && (null === (e = document.activeElement) || void 0 === e || e.blur());
  }
  function j() {
    var t, e;
    null == c || c.classList.toggle("is-syncing", !1 === (null == a ? void 0 : a.hasNavigated()) || (null === (t = null == a ? void 0 : a.getTween()) || void 0 === t ? void 0 : t.isRunning())), L(), (null === (e = null == a ? void 0 : a.getGestures()) || void 0 === e ? void 0 : e.isPointerDown()) && function () {
      if (!p()) return;
      if (!a || !d) return;
      if (!g) return;
      var t = d.getTween(),
        e = d.getPages(),
        n = a.getPageIndex() || 0,
        o = a.getPageProgress() || 0;
      if (!(a && e && e[n] && t)) return;
      var l = t.isRunning() ? t.getCurrentValues().pos : d.getPosition();
      if (void 0 === l) return;
      var s = e[n].pos + o * (f - m);
      s = i(e[0].pos, s, e[e.length - 1].pos), t.from({
        pos: l
      }).to({
        pos: s
      }).start();
    }();
  }
  function w() {
    g = !0;
  }
  function E(t, e) {
    null == d || d.add(y(e), e.index);
  }
  function T(t, e) {
    var n = e.target;
    n && !e.defaultPrevented && "toggle" === n.dataset.thumbsAction && function () {
      if (c || (b(!0), S()), !c) return;
      var t = (null == d ? void 0 : d.isVertical()) ? "maxWidth" : "maxHeight",
        e = c.style[t];
      c.style[t] = e ? "" : "0px";
    }();
  }
  function L() {
    if (!p()) return;
    if (!a || !d) return;
    var t = (null == d ? void 0 : d.getSlides()) || [];
    var e = -.5 * f;
    var _iterator3 = _createForOfIteratorHelper(t),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _n = _step3.value;
        var _t6 = _n.el;
        if (!_t6) continue;
        var _i = a.getPageProgress(_n.index) || 0;
        _i = Math.max(-1, Math.min(1, _i)), _i > -1 && _i < 1 && (e += .5 * f * (1 - Math.abs(_i))), _i = Math.round(1e4 * _i) / 1e4, e = Math.round(1e4 * e) / 1e4, _t6.style.setProperty("--progress", "".concat(Math.abs(_i))), _t6.style.setProperty("--shift", "".concat((null == a ? void 0 : a.isRTL()) ? -1 * e : e, "px")), _i > -1 && _i < 1 && (e += .5 * f * (1 - Math.abs(_i)));
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
  return {
    init: function init(t, e) {
      u = e, a = t, a.on("ready", C), a.on("initSlides", x), a.on("render", j), a.on("change", w);
    },
    destroy: function destroy() {
      var t, e;
      null == a || a.off("ready", C), null == a || a.off("initSlides", x), null == a || a.off("render", j), null == a || a.off("change", w), null == a || a.off("addSlide", E), null == a || a.off("click", T), null === (t = null == a ? void 0 : a.getGestures()) || void 0 === t || t.off("start", P), null === (e = null == a ? void 0 : a.getContainer()) || void 0 === e || e.classList.remove("has-thumbs"), a = void 0, null == d || d.destroy(), d = void 0, null == c || c.remove(), c = void 0;
    },
    getCarousel: function getCarousel() {
      return d;
    },
    getContainer: function getContainer() {
      return c;
    },
    isEnabled: function isEnabled() {
      return v();
    }
  };
};
export { a as Thumbs };